import React from "react";
import "../Pages/CSS/ContactUs.css";

const ContactUs = () => {
  return (
    <div className="contact-container">
      <h2>Contact Us</h2>

      <div className="contact-content">

        {/* ------------------ Contact Info ------------------ */}
        <div className="contact-info">
          <h3>Our Address</h3>
          <p>Shop#2,3 alfatehheights pakistantownphase1 islamabad</p>

          <h3>Email</h3>
          <p>
            <a href="mailto:khanCollection@gmail.com">
              junaidtahirjunibhai@gmail.com
            </a>
          </p>

          <h3>Phone</h3>
          <p>
            <a href="tel:+923013087534">+923148009480</a>
          </p>
        </div>

        {/* ------------------ Google Map ------------------ */}
       <div className="contact-map">
  <iframe
    title="Malik Arcade Location"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d831.0420147863106!2d73.14366256002161!3d33.57498551118146!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38dfed0037fc8303%3A0x9944ff3adf7028eb!2sMalik%20Arcade!5e0!3m2!1sen!2sus!4v1776755793099!5m2!1sen!2sus"
    width="100%"
    height="400"
    style={{ border: 0 }}
    allowFullScreen
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
  ></iframe>
</div>
      </div>
    </div>
  );
};

export default ContactUs;
